<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from "vue";
import VueMask from "v-mask";

Vue.prototype.$CorpCode = "";

Vue.use(VueMask);

export default {
  name: "App",
  components: {}
};
</script>

<style>
@import "~vue-form-wizard/dist/vue-form-wizard.min.css";
@import url("https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/css/bootstrap.min.css");
@import url("https://rawgit.com/lykmapipo/themify-icons/master/css/themify-icons.css");
@import "./assets/Defaults.css";
</style>
